/**
 * @description 底部组件
 */

import {h, Component} from 'preact';
import './footer.scss';
import Face from 'components/face/face';
import FaceMap from 'lib/emoji-map';

import SDK from 'lib/sdk';

const MAX_VALUE_NUM = 200;

export default class Footer extends Component{
  constructor(props){
    super(props);

    this.state = {
      value: '',
      valueNum: 0,
      faces: []
    }
  }

  componentWillMount(){
    window.addEventListener('keyup', this.handleKeyUp.bind(this));
  }

  componentWillUnmount(){
    window.removeEventListener('keyup', this.handleKeyUp);
  }

  sendMsg(){
    if(this.state.valueNum > 200){
      return;
    }

    let endReg = /\s*\<br\s*\/\>\s*$/; //去掉末尾的空格和br标签
		let startReg = /^\s*/;// 去掉开始的空格
		let msg = this.state.value.replace(startReg, '').replace(endReg, '').replace(/\n$/, '');

    this.setState({
      value: '',
      valueNum: 0,
      showFace:false
    });

    if(!msg){
      return ;
    }
    
    SDK.appendMsg(msg);
  }

  handleFaceChoose(value){
    let str = this.state.value + value;
    
    this.setState({
      value: str,
      // faces: this.state.faces.concat(value),
      valueNum: this.state.valueNum + 1
    },()=>{
      this.TEXT_AREA.focus();
    });
  }

  handleKeyDown(ev){
    
		if(ev.keyCode === 8){
			this.preValue = this.state.value;
		}
	}

	handleKeyUp(ev){
		let value = this.state.value;
    
		if(ev.keyCode === 8) {
			if(this.preValue === this.state.value || !value){
				return;
			}

			let valObj = this.checkValue(this.preValue);

			if(valObj.result !== this.preValue){
        // let faces = [].concat(this.state.faces);
        // let index = faces.indexOf(valObj.face);

        // if(index !== -1){
        //   faces.splice(index,1);
        // }
        
				this.setState({
          value: valObj.result,
          // faces: faces
        });
			}
		}

    // 回车发送消息
		if(ev.keyCode === 13 && !ev.shiftKey){
			this.sendMsg();
		}
	}

  handleInput(ev){
    let value = ev.target.value;
    let faces = this.calcFace();
    let num = value.length - faces.join('').length + faces.length;

		this.setState({
      value: value,
      valueNum: num
    });
  }

  handleFoucs(){
    let obj = this.TEXT_AREA,

    pos = this.state.value.length;

    if (obj.createTextRange) {//IE浏览器 IE浏览器中有TextRange  对body,textarea,button有效
        var range = obj.createTextRange(); //创建textRange
        range.moveStart("character", pos); //移动开始点，以字符为单位
        range.collapse(true);//没有移动结束点直接 折叠到一个点
        range.select();//选择这个点
    } else {//非IE浏览器
        obj.setSelectionRange(obj.value.length, pos);
    }   

    obj.focus();     
  }
  calcFace(){
    let reg = /(\[.*?\])/g;
    let matchArr = this.state.value.match(reg);
    let result = [];

    if(matchArr){
      result = matchArr.filter((item)=>{
        if(FaceMap[item]){
          return true;
        }

        return false;
      });
    }

    return result;
  }
  /**
	 * @description 检查末尾是否有表情如果有返回删除最后一个表情的字符串没有则返回传参
	 */
	checkValue(value){
		let result = value;
    let emoji = '';

		if(value && value.slice(-1) === ']'){
			let delIcon = /(\[.*?\])/g;
			let tempArr = value.match(delIcon);

			if(tempArr && tempArr.length > 0){
				emoji = tempArr.slice(-1).toString();

        if(FaceMap[emoji]){
          result = value.slice(0,-emoji.length);
        }else{
          emoji = ''
        }
			}
		}

		return {
      result: result,
      face: emoji
    };
	}

  vTip(){
    let diffNum = MAX_VALUE_NUM - this.state.valueNum;

    if(diffNum >= 0){
      return (
        <span class='footer__options--tip'>还可输入{diffNum}字</span>
      )
    }else{
      return (
        <span class='footer__options--wram'>
          已超过{-diffNum}字
        </span>
      )
    }
    
  }

  render(props, state){
    return (
      <footer class='app__footer'>
        <div class='footer__tool'>
          <div 
            class='footer__tool--icon footer__tool--face' 
            title='表情'
            onClick={()=>{
              this.setState({
                showFace: !state.showFace
              })
            }}
          >
            <Face 
              show={state.showFace}
              class='footer__face' 
              onChoose={this.handleFaceChoose.bind(this)}
            />
            表情
          </div>

          <span 
            class='footer__tool--icon footer__tool--staff' 
            title='人工服务'
            onClick={()=>{SDK.gotoStaffService()}}
          >
            人工
          </span>
        </div>

        <div class='footer__edit'>
          <textarea 
            ref={(ref)=>{this.TEXT_AREA = ref;}}
            class='footer__edit--input' 
            value={state.value} 
            onKeyUp={this.handleKeyUp.bind(this)}
						onKeyDown={this.handleKeyDown.bind(this)}
            onInput={this.handleInput.bind(this)}
            onFocus={this.handleFoucs.bind(this)}
          />
        </div>

        <div class='footer__options'>
          {this.vTip()}
          <span 
            class='footer__options--btn'
            onClick={this.sendMsg.bind(this)}
          >
            发送
          </span>
        </div>

      </footer>
    );

  }
}


/** WEBPACK FOOTER **
 ** ./components/footer/footer.jsx
 **/